import InputBox from "../../../../Component/DigitalMarketing/Forms/InputBox";
import InputSelect from "../../../../Component/DigitalMarketing/Forms/InputSelect";
import TextArea from "../../../../Component/DigitalMarketing/Forms/TextArea";

export const SettingsTabs = [
  { id: 1, name: "Patient detail" },
  { id: 2, name: "e-Prescription" },
  { id: 3, name: "Test reports" },
];
export const ReportsTabs = [
  { id: 1, name: "All" },
  { id: 2, name: "Receipt" },
  { id: 3, name: "Prescription" },
  { id: 4, name: "Medical report" },
  { id: 5, name: "Others" },


];
export function formatDateString(dateStr) {
  const date = new Date(dateStr);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}
export const SourceOption = [
  { id: "facebook", status: "Facebook" },
  { id: "instagram", status: "Instagram" },
  { id: "direct_call", status: "Direct Call" },
  { id: "qr_code", status: "QR Code" },
];
export const SettingsLabel = [
  // {
  //   tag: InputBox,
  //   label: "Hospital Code",
  //   type: "text",
  //   placeholder: "Enter admin name",
  //   key_name: "hospitalCode",
  //   style: "input-grey",
  //   width: 12,
  // },
 {
    tag: InputBox,
    label: "Email",
    type: "email",
    placeholder: "Enter email Id",
    key_name: "email1",
    style: "input-grey",
  },
  {
    tag: InputBox,
    label: "Mobile Number",
    type: "text",
    placeholder: "Enter mobile number",
    key_name: "contact1",
    style: "input-grey",
  },
  {
    tag: TextArea,
    label: "Address",
    placeholder: "Enter address",
    key_name: "address",
    width: 12,
    style: "input-grey-area",
  },
];
export const ProfileLabel = [
  {
    tag: InputBox,
    label: "User Name",
    type: "text",
    placeholder: "Enter your name",
    key_name: "fullName",
    required: true,
    validation: "required",
  },
  {
    tag: InputBox,
    label: "Email Id",
    type: "text",
    placeholder: "Enter email id",
    key_name: "email",
    required: true,
    validation: "email",
  },
  {
    tag: InputBox,
    label: "Mobile Number",
    type: "number",
    placeholder: "Enter mobile number",
    key_name: "phoneNumber",
    required: true,
    validation: "phone",
  },
];
export const PasswordLabel = [
  {
    tag: InputBox,
    label: "Current Password",
    key_name: "oldPassword",
    type: "password",
    placeholder: "**********",
    required: true,
    validation: "required",
  },
  {
    tag: InputBox,
    label: "New Password",
    key_name: "newPassword",
    type: "password",
    placeholder: "**********",
    required: true,
    validation: "required",
  },
  {
    tag: InputBox,
    label: "Confirm New Password",
    key_name: "confirmPassword",
    type: "password",
    placeholder: "**********",
    required: true,
    validation: "required",
  },
];
